import { en as basic } from './namespaces/basic';
import { en as trends } from './namespaces/trends';
import { en as influencers } from './namespaces/influencers';
import { en as hashtags } from './namespaces/hashtags';
import { en as sets } from './namespaces/sets';
import { en as users } from './namespaces/users';
import { en as login } from './namespaces/login';
import { en as videos } from './namespaces/videos';
import { en as entities } from './namespaces/entities';
import { en as news } from './namespaces/news';
import { en as topics } from './namespaces/topics';
import { en as organizations } from './namespaces/organizations';
import { en as settings } from './namespaces/settings';
import { en as reports } from './namespaces/reports';
import { en as notifications } from './namespaces/notifications';
import { en as archive } from './namespaces/archive';
import { en as tweets } from './namespaces/tweets';
import { en as admin } from './namespaces/admin';
import { en as posts } from './namespaces/posts';

export default {
  basic,
  trends,
  influencers,
  hashtags,
  sets,
  users,
  login,
  videos,
  entities,
  news,
  topics,
  organizations,
  settings,
  reports,
  notifications,
  archive,
  tweets,
  admin,
  posts,
};
